import { iconPaths } from '../components/common/icon/icon-paths'

// Icon options for Storybook:
export const iconOptions = Object.keys(iconPaths)

// Icon name type for Icon component
export type IconType = keyof typeof iconPaths
